import gql from 'graphql-tag';

export const _GET_STATEMENT_LINES = gql`
	query getStatementLines($status: [risolto_statement_line_status_enum!], $startDate: date, $endDate: date, $limit: Int = 10, $offset: Int = 0, $participantRef: uuid!) {
		total: risolto_statement_line_aggregate(
			limit: $limit
			offset: $offset
			where: {
				_and: [
					{ status: { _in: $status } }
					{ participant: { _eq: $participantRef } }
					{ transaction_date: { _gte: $startDate } }
					{ transaction_date: { _lte: $endDate } }
				]
			}
		) {
			aggregate {
				count
			}
		}
		statements: risolto_statement_line(
			limit: $limit
			offset: $offset
			where: {
				_and: [
					{ status: { _in: $status } }
					{ participant: { _eq: $participantRef } }
					{ transaction_date: { _gte: $startDate } }
					{ transaction_date: { _lte: $endDate } }
				]
			}
		) {
			reference
			counterparty_account_number
			counterparty_account_number_type
			counterparty_address
			counterparty_bank_identifier
			counterparty_bank_identifier_type
			counterparty_currency
			counterparty_name
			invoice
			recipient_by_reference {
				reference
				name
				channel_endpoints {
					channel
					contact_by_reference {
						first_name
						last_name
					}
				}
			}
			legal_entity
			recipient
			structured_message
			transaction_credit_amount
			transaction_date
			transaction_debit_amount
			transaction_reference
			unstructured_message
		}
	}
`;
